import React, { Component } from 'react';
import {
    Box,
    Typography,
    Avatar,
    IconButton,
    LinearProgress,
    Button,
    TextField,
    InputAdornment
} from '@mui/material';
import {
    Close,
    ShoppingBag,
    Favorite,
    FavoriteBorder,
    Share,
    Send,
    Pause,
    PlayArrow
} from '@mui/icons-material';

class StoryPage extends Component {
    constructor(props) {
        super(props);

        const mockGroups = [
            {
                id: 'loja-1',
                nome: 'Pizzaria Bella Napoli',
                segmento: 'Pizzaria • 2h atrás',
                imagem: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=150',
                slides: [
                    {
                        id: 's1',
                        tipo: 'imagem',
                        imagem: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=800',
                        titulo: 'Pizza Quatro Queijos em Promoção! 🍕',
                        legenda: 'Hoje com 20% de desconto no pedido pelo app.'
                    },
                    {
                        id: 's2',
                        tipo: 'imagem',
                        imagem: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=800',
                        titulo: 'Massa Artesanal Fermentada 🤤',
                        legenda: '48 horas de maturação para uma leveza incomparável.'
                    }
                ]
            }
        ];

        this.state = {
            storyGroups: props.storyGroups || mockGroups,
            groupIndex: 0,
            storySlideIndex: 0,
            storyProgress: 0,
            isPaused: false,
            curtido: false,
            respostaTexto: ''
        };

        this.timer = null;
        this.pressTimer = null;
        this.SLIDE_DURATION = 5000;
        this.UPDATE_INTERVAL = 50;
    }

    componentDidMount() {
        this.iniciarProgresso();
    }

    componentWillUnmount() {
        this.limparTimer();
    }

    iniciarProgresso = () => {
        this.limparTimer();
        this.timer = setInterval(() => {
            if (this.state.isPaused) return;

            this.setState((prevState) => {
                const increment = (this.UPDATE_INTERVAL / this.SLIDE_DURATION) * 100;
                const novoProgresso = prevState.storyProgress + increment;

                if (novoProgresso >= 100) {
                    this.proximoStorySlide();
                    return { storyProgress: 0 };
                }

                return { storyProgress: novoProgresso };
            });
        }, this.UPDATE_INTERVAL);
    };

    limparTimer = () => {
        if (this.timer) clearInterval(this.timer);
    };

    proximoStorySlide = () => {
        const { storyGroups, groupIndex, storySlideIndex } = this.state;
        const grupoAtual = storyGroups[groupIndex];

        if (!grupoAtual) return;

        if (storySlideIndex < grupoAtual.slides.length - 1) {
            this.setState({
                storySlideIndex: storySlideIndex + 1,
                storyProgress: 0,
                curtido: false
            });
        } else if (groupIndex < storyGroups.length - 1) {
            this.setState({
                groupIndex: groupIndex + 1,
                storySlideIndex: 0,
                storyProgress: 0,
                curtido: false
            });
        } else {
            this.fecharStory();
        }
    };

    anteriorStorySlide = () => {
        const { storyGroups, groupIndex, storySlideIndex } = this.state;

        if (storySlideIndex > 0) {
            this.setState({
                storySlideIndex: storySlideIndex - 1,
                storyProgress: 0,
                curtido: false
            });
        } else if (groupIndex > 0) {
            const grupoAnteriorIndex = groupIndex - 1;
            const ultimoSlideAnterior = storyGroups[grupoAnteriorIndex].slides.length - 1;

            this.setState({
                groupIndex: grupoAnteriorIndex,
                storySlideIndex: ultimoSlideAnterior,
                storyProgress: 0,
                curtido: false
            });
        } else {
            this.setState({ storyProgress: 0 });
        }
    };

    handleTouchStart = () => {
        this.pressTimer = setTimeout(() => {
            this.setState({ isPaused: true });
        }, 200);
    };

    handleTouchEnd = () => {
        clearTimeout(this.pressTimer);
        if (this.state.isPaused) {
            this.setState({ isPaused: false });
        }
    };

    togglePausa = () => {
        this.setState((prev) => ({ isPaused: !prev.isPaused }));
    };

    toggleCurtir = () => {
        this.setState((prev) => ({ curtido: !prev.curtido }));
    };

    enviarResposta = () => {
        if (!this.state.respostaTexto.trim()) return;
        console.log('Resposta enviada:', this.state.respostaTexto);
        this.setState({ respostaTexto: '' });
    };

    compartilharStory = () => {
        if (navigator.share) {
            navigator.share({
                title: 'Story Especial',
                text: 'Confira este story!',
                url: window.location.href
            }).catch(() => { });
        } else {
            navigator.clipboard.writeText(window.location.href);
            alert('Link do Story copiado!');
        }
    };

    fecharStory = () => {
        if (this.props.onClose) {
            this.props.onClose();
        } else {
            window.history.back();
        }
    };

    abrirLoja = (loja) => {
        console.log('Navegar para loja:', loja);
        if (this.props.onOpenStore) {
            this.props.onOpenStore(loja);
        }
    };

    render() {
        const {
            storyGroups,
            groupIndex,
            storySlideIndex,
            storyProgress,
            isPaused,
            curtido,
            respostaTexto
        } = this.state;

        const storyAtualGroup = storyGroups[groupIndex];
        const slideAtual = storyAtualGroup?.slides[storySlideIndex];

        if (!storyAtualGroup || !slideAtual) return null;

        return (
            <Box
                sx={{
                    position: 'relative',
                    width: '100vw',
                    height: '100vh',
                    maxWidth: '480px',
                    mx: 'auto',
                    bgcolor: '#000',
                    color: '#fff',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    justify: 'space-between', // Garante a separação Topo / Rodapé
                    userSelect: 'none'
                }}
                onMouseDown={this.handleTouchStart}
                onMouseUp={this.handleTouchEnd}
                onTouchStart={this.handleTouchStart}
                onTouchEnd={this.handleTouchEnd}
            >
                {/* MÍDIA DO STORY */}
                {slideAtual.tipo === 'video' ? (
                    <Box
                        component="video"
                        autoPlay
                        loop
                        muted
                        playsInline
                        src={slideAtual.videoUrl}
                        sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }}
                    />
                ) : (
                    <Box
                        component="img"
                        src={slideAtual?.imagem}
                        alt={slideAtual?.titulo}
                        sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }}
                    />
                )}

                {/* CONTROLES DE TOQUE (ESQUERDA E DIREITA) */}
                <Box
                    onClick={this.anteriorStorySlide}
                    sx={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '35%', zIndex: 3, cursor: 'pointer' }}
                />
                <Box
                    onClick={this.proximoStorySlide}
                    sx={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: '65%', zIndex: 3, cursor: 'pointer' }}
                />

                {/* GRADIENTE DE SOBREPOSIÇÃO (ESCURINHO NO TOPO E NO RODAPÉ) */}
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        background: 'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, transparent 20%, transparent 60%, rgba(0,0,0,0.9) 100%)',
                        zIndex: 2,
                        pointerEvents: 'none'
                    }}
                />

                {/* TOPO: BARRA DE PROGRESSO + CABEÇALHO */}
                <Box sx={{ position: 'relative', zIndex: 4 }}>
                    {/* BARRA DE PROGRESSO */}
                    <Box sx={{ pt: 1.5, px: 2, display: 'flex', gap: 0.8 }}>
                        {storyAtualGroup.slides?.map((s, idx) => (
                            <LinearProgress
                                key={s.id}
                                variant="determinate"
                                value={
                                    idx < storySlideIndex
                                        ? 100
                                        : idx === storySlideIndex
                                            ? storyProgress
                                            : 0
                                }
                                sx={{
                                    flexGrow: 1,
                                    height: 3,
                                    borderRadius: 2,
                                    bgcolor: 'rgba(255,255,255,0.3)',
                                    '& .MuiLinearProgress-bar': {
                                        bgcolor: '#fff',
                                        transition: isPaused ? 'none' : 'transform 0.05s linear'
                                    }
                                }}
                            />
                        ))}
                    </Box>

                    {/* CABEÇALHO */}
                    <Box sx={{ px: 2, pt: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar src={storyAtualGroup.imagem} sx={{ width: 38, height: 38, border: '2px solid #562dab' }} />
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
                                    {storyAtualGroup.nome}
                                </Typography>
                                <Typography variant="caption" sx={{ opacity: 0.8, fontSize: '11px' }}>
                                    {storyAtualGroup.segmento}
                                </Typography>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <IconButton onClick={this.togglePausa} sx={{ color: '#fff' }}>
                                {isPaused ? <PlayArrow fontSize="small" /> : <Pause fontSize="small" />}
                            </IconButton>
                            <IconButton onClick={this.fecharStory} sx={{ color: '#fff' }}>
                                <Close />
                            </IconButton>
                        </Box>
                    </Box>
                </Box>

                {/* ESPAÇADOR FLEXÍVEL - Empurra o conteúdo abaixo direto para o rodapé */}
                <Box sx={{ flexGrow: 1 }} />

                {/* RODAPÉ: TEXTOS + BOTÃO DE COMPRA + BARRINHA DE INTERAÇÃO */}
                <Box sx={{ position: 'relative', zIndex: 4, p: 2, pb: 3 }}>
                    {/* Título e Legenda */}
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="h6" sx={{ fontWeight: 800, mb: 0.5, lineHeight: 1.2 }}>
                            {slideAtual?.titulo}
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.9, color: '#e0e0e0' }}>
                            {slideAtual?.legenda}
                        </Typography>
                    </Box>

                    {/* Botão de Compra */}
                    <Button
                        fullWidth
                        variant="contained"
                        startIcon={<ShoppingBag />}
                        onClick={() => this.abrirLoja(storyAtualGroup)}
                        sx={{
                            bgcolor: '#562dab',
                            color: '#fff',
                            fontWeight: 800,
                            py: 1.4,
                            borderRadius: '12px',
                            textTransform: 'none',
                            fontSize: '15px',
                            mb: 2,
                            '&:hover': { bgcolor: '#432188' }
                        }}
                    >
                        Ir para a Loja & Comprar
                    </Button>

                    {/* Campo de Resposta / Ações Sociais */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Enviar mensagem..."
                            value={respostaTexto}
                            onChange={(e) => this.setState({ respostaTexto: e.target.value })}
                            onKeyPress={(e) => e.key === 'Enter' && this.enviarResposta()}
                            InputProps={{
                                endAdornment: respostaTexto && (
                                    <InputAdornment position="end">
                                        <IconButton size="small" onClick={this.enviarResposta} sx={{ color: '#ffb142' }}>
                                            <Send fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.15)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '25px',
                                input: { color: '#fff', fontSize: '13px', px: 2 },
                                '& fieldset': { border: '1px solid rgba(255,255,255,0.2)' },
                                '& .MuiInputBase-root': { borderRadius: '25px' }
                            }}
                        />

                        <IconButton onClick={this.toggleCurtir} sx={{ color: curtido ? '#ff4757' : '#fff' }}>
                            {curtido ? <Favorite /> : <FavoriteBorder />}
                        </IconButton>

                        <IconButton onClick={this.compartilharStory} sx={{ color: '#fff' }}>
                            <Share />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default StoryPage;